import { createAction, handleActions } from 'redux-actions';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { requestDMPost, requestQuality } from 'modules/fetch/api';
import { setChatList } from 'modules/actions/chat';
import { activeModal } from 'modules/actions/statusMenu';
import uuid4 from 'uuid/v4';

const SET_MESSAGE_ID = 'quality/SET_MESSAGE_ID';
const SET_OPTIONS = 'quality/SET_OPTIONS';
const FETCH_OPTIONS = 'quality/FETCH_OPTIONS';
const SEND_QUALITY = 'quality/SEND_QUALITY';
const SET_RESPONSE = 'quality/SET_RESPONSE';
const SET_QUALITY = 'quality/SET_QUALITY';
const SET_RECHECK_QUALITY = 'quality/SET_RECHECK_QUALITY';
const SET_SELECTED_MSG_ID = 'quality/SET_SELECTED_MSG_ID';


export const setQuality = createAction(SET_QUALITY);
export const sendQuality = createAction(SEND_QUALITY);
export const fetchOptions = createAction(FETCH_OPTIONS);
export const setMessageId = createAction(SET_MESSAGE_ID);
export const setOptions = createAction(SET_OPTIONS);
export const setResponse = createAction(SET_RESPONSE);
export const setRecheckQuality = createAction(SET_RECHECK_QUALITY);
export const setSelectedMsgId = createAction(SET_SELECTED_MSG_ID)

 export function* fetchQualityOptions() {
  const {
    data: { quality },
  } = yield call(requestQuality);
  yield put(setOptions(quality));
} 

export function* getQualityOptions() {
  yield takeLatest(FETCH_OPTIONS, fetchQualityOptions);
} 

export function* createQuality(action) {
  console.log('createQuality :::');
  const messageId = action.payload.message_id === undefined ? `${uuid4()}` : action.payload.message_id;
  const dialogueId =  action.payload.dialogue_id === undefined ? `${uuid4()}` : action.payload.dialogue_id;
  console.log("createQuality actionPayload :::", JSON.stringify(action));  
  console.log("test = ", `${uuid4()}`);
  const param = {
	  param: {
          session_id: sessionStorage.getItem('session_id'),
	        message_id: 'aaa' ,
          token : process.env.REACT_APP_TOKEN,
          domain_id: process.env.REACT_APP_DOMAIN_ID,
	        ...action.payload
	  }
  };
  param.param.message_id = messageId;
  param.param.dialogue_id = dialogueId;
  console.log("param. param = ", JSON.stringify(param.param));

   const response = yield call(requestDMPost, param);
   console.log("createQuality response = ", response); 
   yield put(setResponse([{ text : '소중한 의견 감사합니다.'}]));
   yield put(activeModal('feedbackResponseModal'));
}

export function* sendQualityGenerator() {
  yield takeLatest(SEND_QUALITY, createQuality);
}

export function* checkQuality() {
   yield put(setResponse([{ text : '평가 및 의견 작성을 완료해주세요.'}]));
   yield put(activeModal('feedbackResponseModal'));
}

export function* checkQualityGenerator() {
  yield takeLatest(SET_RECHECK_QUALITY, checkQuality);
}


const quality = handleActions(
  {
    [SET_QUALITY]: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    [SET_MESSAGE_ID]: (state, action) => {
      return {
        ...state,
        messageId: action.payload,
      };
    },
    [SET_OPTIONS]: (state, action) => {
      return {
        ...state,
        options: action.payload,
      };
    },
    [SET_RESPONSE]: (state, action) => {
      return {
        ...state,
        response: action.payload,
      };
    },

    [SET_RECHECK_QUALITY]: (state, action) => {
      return {
        ...state
      };
    },

   [SET_SELECTED_MSG_ID]: (state, action) => {
      return {
        ...state,
        selectedMsgId: action.payload,
      };
    },

  },
  {
    messageId: '',
    response: [],
    options: [],
  }
);

export default quality;
